import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'
import {
  GA_IDS_BY_HOSTNAME,
  GTM_IDS_BY_HOSTNAME,
  CHEC_QA_HOST,
} from 'utils/constants'
import { prop, path } from 'ramda'

window.dataLayer = window.dataLayer || []

export function dataLayer(event) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
  return window.dataLayer
}

export function event(eventProps) {
  if (!shouldTrack()) return

  const { category, action, label, value } = eventProps

  ReactGA.event({
    category,
    action,
    label,
    value,
  })
}

export function dimensions(dims) {
  if (shouldTrack()) ReactGA.set(dims)
}

export function exception(exception) {
  if (shouldTrack())
    dataLayer({
      event: 'exception',
      exception,
    })
}

export function pageView(path) {
  if (shouldTrack()) ReactGA.pageview(path)
}

export function initialize() {
  if (!shouldTrack()) return
  const hostname = path(['location', 'hostname'], window)
  const gaId = prop(hostname, GA_IDS_BY_HOSTNAME)
  if (gaId) {
    const isInternalStage = hostname === CHEC_QA_HOST
    ReactGA.initialize(gaId, {
      ...(isInternalStage && { debug: true }),
    })
    pageView(window.location.pathname + window.location.search)
  }

  const gtmId = prop(hostname, GTM_IDS_BY_HOSTNAME)
  if (gtmId) {
    TagManager.initialize({
      gtmId,
    })
  }
}

const shouldTrackHostname = (hostname) =>
  Object.keys({ ...GA_IDS_BY_HOSTNAME, ...GTM_IDS_BY_HOSTNAME }).includes(
    hostname
  )

export function shouldTrack() {
  const hostname = path(['location', 'hostname'], window)
  return (
    shouldTrackHostname(hostname) &&
    process.env.REACT_APP_ENABLE_ANALYTICS_TRACKING
  )
}
